module.exports = __webpack_public_path__ + "img/paypal_logo.fb869d0e.png";